module.exports = __webpack_public_path__ + "static/media/ndi-mpu.fcdd5402.gif";